import React, { useState } from "react";
import PropTypes from "prop-types";
import { publicationsApiRequest } from "../../../api";
import Slideshow from "../Slideshow";
import Slide from "./Slide";
import Details from "./Details";

const PublicationSlider = ({ artistId }) => {
  const query = { page: 1, artist: artistId };
  const [publications, setPublications] = useState();
  const [activeIndex, setActiveIndex] = useState(0);

  function onSuccess(response) {
    if (response.records && response.records.length > 0) {
      setPublications(response.records);
    }
  }

  const fetchData = () => {
    publicationsApiRequest(query, onSuccess);
  };

  if (!publications) {
    fetchData();
  }

  const imageWidth = 670;

  const renderSlide = (publication, index) => {
    return (
      <Slide
        imgRetina={publication.featured_image_retina}
        imgDefault={publication.featured_image_default}
        alt={publication.image_alt}
        width={imageWidth}
      />
    );
  };

  const onUpdate = (index) => {
    setActiveIndex(index);
  };

  return publications ? (
    <>
      <div className="l-pad-bottom-small">
        <Slideshow
          renderSlide={renderSlide}
          slides={publications}
          active={activeIndex}
          onUpdate={onUpdate}
        />
      </div>
      <Details
        name={publications[activeIndex].name}
        description={publications[activeIndex].description}
        url={publications[activeIndex].url}
      />
    </>
  ) : null;
};

PublicationSlider.propTypes = {
  artistId: PropTypes.number,
};

export default PublicationSlider;
